import React from 'react';
import { MessageSquare, Calendar, Pill, Shield, HeartPulse, Users } from 'lucide-react';
export function Features() {
  // Define the gradient for icons
  const iconGradient = <linearGradient id="iconGradient" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-33">
      <stop offset="0%" stopColor="#BBDDFF" data-id="element-34" />
      <stop offset="100%" stopColor="#C85A15" data-id="element-35" />
    </linearGradient>;
  // Custom icon component that applies the gradient
  const GradientIcon = ({
    icon: Icon
  }) => <div className="relative" data-id="element-36">
      <svg width="0" height="0" className="absolute" data-id="element-37">
        {iconGradient}
      </svg>
      <Icon size={24} className="stroke-[url(#iconGradient)]" strokeWidth={2} data-id="element-38" />
    </div>;
  const features = [{
    icon: <GradientIcon icon={HeartPulse} data-id="element-39" />,
    title: 'Real-time Health Monitoring',
    description: 'Doctors receive live updates on your progress for truly personalized care.'
  }, {
    icon: <GradientIcon icon={MessageSquare} data-id="element-40" />,
    title: 'Unified Communications',
    description: 'Seamless doctor-patient messaging for continuous support throughout your health journey.'
  }, {
    icon: <GradientIcon icon={Calendar} data-id="element-41" />,
    title: 'Effortless Scheduling',
    description: 'Book appointments with specialists instantly, without the usual wait times.'
  }, {
    icon: <GradientIcon icon={Pill} data-id="element-42" />,
    title: 'Prescription Automation',
    description: 'Streamlined medication management with deliveries from US-based and globally recognized pharmacies.'
  }, {
    icon: <GradientIcon icon={Shield} data-id="element-43" />,
    title: 'HIPAA Compliant Security',
    description: 'Enterprise-grade protection for your sensitive health information.'
  }, {
    icon: <GradientIcon icon={Users} data-id="element-44" />,
    title: 'Dedicated Provider Network',
    description: 'JoinOmu patients receive treatment from licensed physicians who are recognized for excellence in their field.'
  }];
  return <section id="features" className="py-24 relative overflow-hidden" data-id="element-45">
      {/* Decorative elements */}
      <div className="absolute -top-[10%] -right-[10%] w-[70%] h-[70%] rounded-full bg-[#BBDDFF]/10 blur-3xl" data-id="element-46"></div>
      <div className="absolute -bottom-[10%] -left-[10%] w-[70%] h-[70%] rounded-full bg-[#C85A15]/5 blur-3xl" data-id="element-47"></div>
      <div className="container mx-auto px-6 relative z-10" data-id="element-48">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-49">
          <div className="inline-block mb-4 px-4 py-1 rounded-full bg-gradient-to-r from-[#BBDDFF]/10 to-[#C85A15]/10 backdrop-blur-sm border border-white/10" data-id="element-50">
            <span className="text-sm font-medium" data-id="element-51">Our Platform</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-52">
            <span className="bg-gradient-to-r from-gray-900 to-gray-700 dark:from-white dark:to-gray-300 bg-clip-text text-transparent" data-id="element-53">
              The infrastructure powering next-generation care
            </span>
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-300" data-id="element-54">
            Our in-house technology platform delivers a seamless experience for
            both patients and providers, creating a new standard for digital
            healthcare.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-55">
          {features.map((feature, index) => <div key={index} className="bg-white dark:bg-gray-800/50 rounded-2xl p-8 shadow-lg border border-gray-100 dark:border-gray-700/30 backdrop-blur-sm hover:shadow-xl transition-all group" data-id="element-56">
              <div className="w-12 h-12 rounded-full bg-gray-100 dark:bg-gray-700/50 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-57">
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-58">{feature.title}</h3>
              <p className="text-gray-600 dark:text-gray-300" data-id="element-59">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}